module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-container', [_c('v-card', [_c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-container', {
    attrs: {
      "grid-list-md": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Type",
      "items": _vm.types,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.question.type),
      callback: function($$v) {
        _vm.$set(_vm.question, "type", $$v)
      },
      expression: "question.type"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Niveau",
      "items": _vm.levels,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": _vm.onChanged
    },
    model: {
      value: (_vm.question.level),
      callback: function($$v) {
        _vm.$set(_vm.question, "level", $$v)
      },
      expression: "question.level"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Diabète",
      "value": _vm.diabetesStringToList(_vm.question.diabete),
      "multiple": "",
      "chips": "",
      "items": _vm.diabetes,
      "item-text": "name",
      "item-value": "uid"
    },
    on: {
      "change": function($event) {
        _vm.onDiabetesChanged(_vm.question, $event)
      }
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-select', {
    attrs: {
      "label": "Cholestérol",
      "value": _vm.cholesterolStringToList(_vm.question.chol),
      "multiple": "",
      "chips": "",
      "items": _vm.cholesterols,
      "item-text": "short",
      "item-value": "uid"
    },
    on: {
      "change": function($event) {
        _vm.onCholesterolChanged(_vm.question, $event)
      }
    }
  })], 1), _vm._v(" "), (_vm.question.type !== 'intruder') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.question.type !== 'intruder') ? _c('v-textarea', {
    attrs: {
      "label": "Libellé question",
      "rules": _vm.requiredRules
    },
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.question.question),
      callback: function($$v) {
        _vm.$set(_vm.question, "question", $$v)
      },
      expression: "question.question"
    }
  }) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Note"
    },
    on: {
      "input": _vm.onChanged
    },
    model: {
      value: (_vm.question.note),
      callback: function($$v) {
        _vm.$set(_vm.question, "note", $$v)
      },
      expression: "question.note"
    }
  })], 1), _vm._v(" "), (_vm.question.type === 'truefalse') ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Images illustratives")]), _vm._v(" "), _c('v-layout', {
    attrs: {
      "column": "",
      "wrap": ""
    }
  }, _vm._l((_vm.images), function(image) {
    return _c('div', [_c('img', {
      attrs: {
        "src": '/static/media/' + image.pict,
        "width": "150"
      }
    })])
  }))], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('div', {
    staticClass: "title"
  }, [_vm._v("Choix proposés")]), _vm._v(" "), _vm._l((_vm.items), function(item) {
    return _c('div', [(item.pict) ? _c('img', {
      attrs: {
        "src": '/static/media/' + item.pict,
        "width": "150"
      }
    }) : _vm._e(), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.proposition))]), _vm._v(" "), _c('div', [_vm._v(_vm._s(item.answer))]), _vm._v(" "), _c('v-spacer')], 1)
  })], 2), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(_vm.questionId === 0) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.dirty || !_vm.valid,
      "flat": ""
    },
    on: {
      "click": _vm.create
    }
  }, [_vm._v("Créer")]) : _vm._e(), _vm._v(" "), (_vm.questionId !== 0) ? _c('v-btn', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "disabled": !_vm.dirty || !_vm.valid,
      "flat": ""
    },
    on: {
      "click": _vm.update
    }
  }, [_vm._v("Enregistrer")]) : _vm._e()], 1)], 1)], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-375177d7","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/nutrikiosk/QCUQuestion.vue
// module id = 1183
// module chunks = 1